module.exports = __webpack_public_path__ + "static/media/19ESCAP39.7b4c0f25.jpg";